import { API } from "@aws-amplify/api";
import { FeatureFlagResponse } from "src/global";

import { API_METRICS_HANDLE } from "@/apis/constants";
import { Logger } from "@/apis/Logger";
import {
  publishQueryLatencyMetrics,
  publishQueryResultMetrics,
} from "@/apis/Metrics";

import { AMPLIFY_DEFAULT_API_NAME } from "../amplifyConfig";

export const GET_FEATURE_FLAGS_METRIC_NAME = "Features";
export const GET_FEATURE_FLAGS_D1_API_PATH = "/app/features/d1";

/**
 * Fetch feature flag configuration from API and submit latency metrics.
 */
export const fetchFeatureFlags = async (): Promise<FeatureFlagResponse> => {
  const startTime = performance.now();
  try {
    const response = (await API.get(
      AMPLIFY_DEFAULT_API_NAME,
      GET_FEATURE_FLAGS_D1_API_PATH,
      {}
    )) as FeatureFlagResponse;

    publishQueryResultMetrics({
      queryFunctionName: GET_FEATURE_FLAGS_METRIC_NAME,
      metricsPublisherHandler: API_METRICS_HANDLE,
      numSuccess: 1,
      numFailures: 0,
    });

    return response;
  } catch (err) {
    void Logger.errorErrorLike(
      `${GET_FEATURE_FLAGS_METRIC_NAME} failed API call.`,
      err
    );
    publishQueryResultMetrics({
      queryFunctionName: GET_FEATURE_FLAGS_METRIC_NAME,
      metricsPublisherHandler: API_METRICS_HANDLE,
      numSuccess: 0,
      numFailures: 1,
    });
    return Promise.reject(err);
  } finally {
    publishQueryLatencyMetrics({
      metricsPublisherHandler: API_METRICS_HANDLE,
      queryFunctionName: GET_FEATURE_FLAGS_METRIC_NAME,
      elapsedTime: performance.now() - startTime,
    });
  }
};
